// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor {
    'name'?: string | null;
    'id'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor.attributeTypeMap;
    }
}
